import { render, staticRenderFns } from "./LibreriaCodiciConto.vue?vue&type=template&id=537039a1&scoped=true"
import script from "./LibreriaCodiciConto.vue?vue&type=script&lang=js"
export * from "./LibreriaCodiciConto.vue?vue&type=script&lang=js"
import style0 from "./LibreriaCodiciConto.vue?vue&type=style&index=0&id=537039a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537039a1",
  null
  
)

export default component.exports